document.addEventListener('DOMContentLoaded', function() {
            const toggleBtn = document.getElementById('toggleBtn');
            const descriptionContent = document.getElementById('collectionDescription');
            
            if (!toggleBtn || !descriptionContent) {
                console.error('Elements not found!');
                return;
            }
            
            // Configuration - WORKS ON BOTH DESKTOP AND MOBILE NOW!
            const mobileCharLimit = 300;
            const desktopCharLimit = 300;  // Super low to guarantee button shows on desktop
            const mobileBreakpoint = 768;
            
            // Translation detection
            const lang = document.documentElement.lang || 'en';
            // Normalize to just "fr" or "en"
            const baseLang = lang.split('-')[0]; 

            const translations = {
            en: { showMore: 'Show More', showLess: 'Show Less' },
            fr: { showMore: 'Voir plus', showLess: 'Voir moins' }
            };

            const t = translations[baseLang] || translations.en;
            
            let isExpanded = false;
            let originalContent = descriptionContent.innerHTML;
            let textContent = descriptionContent.textContent || descriptionContent.innerText;
            
           
            
            function truncateText(text, limit) {
                if (text.length <= limit) return text;
                let truncated = text.substring(0, limit);
                const lastSpace = truncated.lastIndexOf(' ');
                if (lastSpace > 0) truncated = truncated.substring(0, lastSpace);
                return truncated + '...';
            }
            
            function initializeDescription() {
                const isMobile = window.innerWidth <= mobileBreakpoint;
                const charLimit = isMobile ? mobileCharLimit : desktopCharLimit;
              
                
                // Check BOTH desktop AND mobile - this is the key fix!
                if (textContent.length > charLimit) {
                    
                    const truncatedText = truncateText(textContent, charLimit);
                    descriptionContent.innerHTML = '<p>' + truncatedText + '</p>';
                    toggleBtn.textContent = t.showMore;
                    toggleBtn.style.display = 'block';
                    toggleBtn.style.visibility = 'visible';
                    isExpanded = false;
                } else {
                    
                    descriptionContent.innerHTML = originalContent;
                    toggleBtn.style.display = 'none';
                    isExpanded = true;
                }
            }
            
            function toggleDescription() {
                const isMobile = window.innerWidth <= mobileBreakpoint;
                const charLimit = isMobile ? mobileCharLimit : desktopCharLimit;
                
                 
                if (isExpanded) {
                    // Collapse
                    const truncatedText = truncateText(textContent, charLimit);
                    descriptionContent.innerHTML = '<p>' + truncatedText + '</p>';
                    toggleBtn.textContent = t.showMore;
                    isExpanded = false;
                } else {
                    // Expand
                    descriptionContent.innerHTML = originalContent;
                    toggleBtn.textContent = t.showLess;
                    isExpanded = true;
                }
            }
            
            toggleBtn.addEventListener('click', toggleDescription);
            
            let resizeTimeout;
            window.addEventListener('resize', function() {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(initializeDescription, 250);
            });
            
            // Initialize immediately
            initializeDescription();
            
           
        });